const POST_LOGIN_REDIRECT_KEY = 'postLoginRedirect';

export function setPostLoginRedirect(route) {
    if (!route || !route.path) return;
    sessionStorage.setItem(POST_LOGIN_REDIRECT_KEY, JSON.stringify({
        path: route.path,
        query: route.query || {},
    }));
}

export function consumePostLoginRedirect() {
    const raw = sessionStorage.getItem(POST_LOGIN_REDIRECT_KEY);
    if (!raw) return null;
    sessionStorage.removeItem(POST_LOGIN_REDIRECT_KEY);
    try {
        const route = JSON.parse(raw);
        return route && route.path ? route : null;
    } catch (_) {
        return null;
    }
}

export function getPostLoginRedirect() {
    const raw = sessionStorage.getItem(POST_LOGIN_REDIRECT_KEY);
    if (!raw) return null;
    try {
        const route = JSON.parse(raw);
        return route && route.path ? route : null;
    } catch (_) {
        return null;
    }
}

export function getRouteAfterLogin(userInfoCollection) {
    if (userInfoCollection && userInfoCollection.length > 0) {
        return { path: '/register_info' };
    }
    return consumePostLoginRedirect() || { path: '/' };
}
